
/**
* Licensed Materials - Property of IBM
* IBM Cognos Products: ba-dashboard-core
* (C) Copyright IBM Corp. 2018, 2020
* US Government Users Restricted Rights - Use, duplication or disclosure restricted by GSA ADP Schedule Contract with IBM Corp.
*/
define({
	'createDashboardTitle': 'Criar painel',
	'dashboard': 'Painel',
	'dashboardTemplate': 'Gabarito do Painel Digital',
	'createAV': 'Criar',
	'createAvEditNameLabel': '1. Nomear sua visualização',
	'createAvSelectTemplateLabel': '2. Selecionar um gabarito',
	'tabLayoutLabel': 'Modelo com guias',
	'infographicsLayoutLabel': 'Modelo infográfico',
	'singlePageLayoutLabel': 'Modelo de página único',
	'customLayoutLabel': 'Modelo customizado',
	'freeformTemplate': 'Forma livre',
	'freeformTemplateDesc': 'Visualizações em um layout de formato livre aparecem exatamente conforme são dimensionada e colocadas para visualização, independentemente do tamanho da tela. Em outros layouts, o tamanho e a posição das visualizações ajustam-se à tela.',
	'NoTemplate': 'Formulário livre',
	'Template1': 'Em branco',
	'Template2': 'Título 1 por 2',
	'Template3': '2 sobre 1',
	'Template4': '4 sobre 1',
	'Template5': 'Rodapé 1 por 2',
	'Template6': '3 ao lado de 1 sobre 1',
	'Template7': '4 ao lado de 3 sobre 1',
	'Template8': '2 sobre 3 por 2',
	'Template9': '2 por 2',
	'Template10': '1 por 2 ao lado de 2 por 2 sobre 1',
	'Template11': '3 por 1 sobre 1 por 2',
	'Template12': '2 sobre 1 ao lado de 1 por 2',
	'Template13': '1 ao lado de 1 por 2 ao lado de 1 por 4',
	'Template14': 'Branco com área de lançamento',
	'Infographics1': 'Em branco',
	'Infographics2': '4 linhas',
	'Infographics3': '4 linhas com cabeçalhos',
	'Infographics4': '2 por 4',
	'Infographics5': 'Grande exibição de parte superior com 2 por 2',
	'Infographics6': '2 por 4 com diferença vertical',
	'Infographics7': '2 por 4 escalonado',
	'Infographics8': 'Quadra de tênis',
	'Infographics9': '3 por 4',
	'Infographics10': '4 por 8',
	'createAvDashboardLabel': 'Layout',
	'dashboard_template_save_success': 'Seu modelo de painel foi salvo.',
	'dashboard_template_prefix': 'Modelo: \'%{name}\'',
	'dashboard_template_filters_removed': 'Os filtros da tela foram removidos.',
	'createAvTabLabel': 'Tabulada',
	'createAvInfographicsLabel': 'Infográfico',
	'createAvSinglepageLabel': 'Página única',
	'createAvCustomLabel': 'Personalização',
	'loadMoreLabel': 'Carregar mais...',
	'backLabel': 'Voltar',
	'addSourceLabel': 'Incluir uma origem',
	'pinLabel': 'Número de Identificação Pessoal',
	'errorLoadingDataSetMetaData': 'Ocorreu um erro ao ler os metadados',
	'errorLoadingDataSets': 'Ocorreu um erro durante o carregamento da lista de conjunto de dados',
	'errorLoadingDataSet': 'Os metadados para o conjunto de dados \'%{datasetName}\' não foram carregados. Entre em contato com seu administrador para obter detalhes.',
	'okButton': 'OK',
	'createButton': 'Criar',
	'cancelButton': 'Cancelar',
	'copyButton': 'Copiar',
	'selectTemplateLabel': 'Selecionar um gabarito',
	'noSourcesSelectedLabel': 'Nenhuma origem selecionada',
	'find_label': 'Localizar',
	'noDashboardFound': 'O painel não pode ser recuperado. Ele não existe mais ou você não tem privilégios suficientes para visualizá-lo.',
	'errorLabel': 'Erro',
	'defaultName': 'Novo painel',
	'noDashboardCapability': 'Você não tem a capacidade para executar o aplicativo de painel',
	'noDashboardPermission': 'Você não tem privilégios suficientes para visualizar este painel',
	'sourceNotFound': 'Não é possível carregar a visualização porque sua origem associada \'%{sourceName}\' não está disponível',
	'cmDuplicateName': 'Um item com esse nome já existe. Tente outro nome',
	'cmEmptySelection': 'O painel foi excluído. Tente salvar como um novo painel.',
	'propTheme': 'Tema visual',
	'defaultThemeLabel': 'Padrão',
	'lightThemeLabel': 'Claro',
	'darkThemeLabel': 'Escuro',
	'titleTextLabel': 'Título',
	'titleSmallTextLabel': 'Título Pequeno',
	'subtitleTextLabel': 'Subtítulo',
	'bodyTextLabel': 'Corpo',
	'bodySmallTextLabel': 'Corpo Pequeno',
	'captionTextLabel': 'Texto Explicativo',
	'quoteTextLabel': 'Citar',
	'quoteSmallTextLabel': 'Citação Pequena',
	'responsiveTextLabel': 'Dimensionamento automático',
	'mediaWidgetLabel': 'Mídia',
	'webpageWidgetLabel': 'Página da Web',
	'imageWidgetLabel': 'Imagem',
	'textWidgetLabel': 'Texto',
	'notebookWidgetLabel': 'Anotações',
	'multipurposeWidgetLabel': 'Multifinalidade',
	'textPlaceHolder': 'Digite seu texto aqui',
	'titlePlaceHolder': 'Insira seu título aqui',
	'toggleEditModeLabel': 'Alternar para edição',
	'togglePreviewModeLabel': 'Alternar para visualização',
	'editDashboardCoachMarkTitle': 'Editar o painel',
	'editDashboardCoachMarkContents': 'Clique no ícone de lápis para editar este painel.',
	'addDataCoachMarkTitle': 'Incluir dados',
	'addDataDashboardCoachMarkContents': 'Arrastar e soltar dados a partir do painel de dados em seu painel.',
	'pageSelectWarning': 'Selecione uma guia.',
	'screenshot_label': 'Painel %{title}',
	'screenshot_label_tab': 'Guia %{tabName} do painel  %{title}',
	'dataAssetPropertiesLabel': 'Propriedades de visualização',
	'modelFilter': 'Filtrar',
	'invertSelectionToolTip': 'Inverter seleções de filtro',
	'clearFilterValueToolTip': 'Limpar valores de filtro',
	'invertFilterSelection': 'Inverter',
	'clearTextFilterValue': 'Limpar',
	'filterConditionLabel': 'Condição do Filtro',
	'applyFilter': 'Aplicar filtro',
	'itemCountText': '%{itemCount} Item(s) selecionado(s)',
	'itemExcludeCountText': '%{itemCount} Item(s) excluído(s)',
	'moreMembers': 'Mostrar mais...',
	'searchHierarchyMembers': 'Utilizar procura para localizar membros...',
	'propHideEmpty': 'Ocultar vazio',
	'propColorOrder': 'Cor da ordem',
	'propElementColor': 'Cor do elemento de visualização',
	'propLineColor': 'Cor da linha',
	'propLineAndSymbolColor': 'Cor de linha e símbolo',
	'propColumnColor': 'Cor da coluna',
	'propBarColor': 'Cor da barra',
	'propWordColor': 'Cor da palavra',
	'propAreaColor': 'Cor da área',
	'propRadialbarColor': 'Cor da barra radial',
	'propColorPalettes': 'Paletas de cores',
	'propDashboardColorPalette': 'Paleta do painel atual',
	'propNewDashboardPaletteLabel': 'Criar uma Paleta de Painel Customizado',
	'propDashboardChangePaletteLink': 'Altere a paleta do painel',
	'propHideLeafNode': 'Ocultar rótulos principais',
	'propOpacity': 'Opacidade',
	'propOpacityDescription': 'Tornar o objeto mais ou menos opaco. Digite um valor entre 0 e 100',
	'addATab': 'Incluir uma nova tabela',
	'propFredIsRed': 'Consistência de cor',
	'areaChartCaption': 'Área',
	'areaChartDataSlot_categoriesLabel': 'Etiqueta do eixo',
	'areaChartDataSlot_valuesLabel': 'Valor',
	'areaChartProp_colorPaletteLabel': 'Paletas de cores',
	'areaChartProp_lineColorLabel': 'Cor da área',
	'areaChartProp_interpolationLabel': 'Linhas suaves',
	'areaChartProp_interpolationDescription': 'As linhas que conectam os pontos de dados são curvadas.',
	'areaChartProp_hideGridLinesLabel': 'Ocultar linhas de grade',
	'areaChartProp_hideGridLinesDescription': 'Ocultar linhas de grade',
	'areaChartProp_hideAxisTitleLabelsLabel': 'Ocultar rótulos do título do eixo',
	'areaChartProp_hideAxisTitleLabelsDescription': 'Ocultar os títulos para os eixos.',
	'areaChartProp_maintainAxisScalesLabel': 'Manter escala do eixo',
	'areaChartProp_maintainAxisScalesDescription': 'Sempre exibir os valores mínimo e máximo nos eixos.',
	'areaChartProp_suppressZerosLabel': 'Ocultar vazio',
	'areaChartProp_suppressZerosDescription': 'Ocultar categorias sem nenhum valor associado.',
	'barChartCaption': 'Barra',
	'barChartDataSlot_categoriesLabel': 'Etiqueta do eixo',
	'barChartDataSlot_valuesLabel': 'Valor',
	'barChartProp_colorPaletteLabel': 'Paletas de cores',
	'barChartProp_elementColorLabel': 'Cor da barra',
	'barChartProp_hideGridLinesLabel': 'Ocultar linhas de grade',
	'barChartProp_hideGridLinesDescription': 'Ocultar linhas de grade',
	'barChartProp_hideAxisTitleLabelsLabel': 'Ocultar rótulos do título do eixo',
	'barChartProp_hideAxisTitleLabelsDescription': 'Ocultar os títulos para os eixos.',
	'barChartProp_maintainAxisScalesLabel': 'Manter escala do eixo',
	'barChartProp_maintainAxisScalesDescription': 'Sempre exibir os valores mínimo e máximo nos eixos.',
	'barChartProp_suppressZerosLabel': 'Ocultar vazio',
	'barChartProp_suppressZerosDescription': 'Ocultar categorias sem nenhum valor associado.',
	'columnChartCaption': 'Coluna',
	'columnChartDataSlot_categoriesLabel': 'Etiqueta do eixo',
	'columnChartDataSlot_valuesLabel': 'Valor',
	'columnChartProp_colorPaletteLabel': 'Paletas de cores',
	'columnChartProp_elementColorLabel': 'Cor da coluna',
	'columnChartProp_hideGridLinesLabel': 'Ocultar linhas de grade',
	'columnChartProp_hideGridLinesDescription': 'Ocultar linhas de grade',
	'columnChartProp_hideAxisTitleLabelsLabel': 'Ocultar rótulos do título do eixo',
	'columnChartProp_hideAxisTitleLabelsDescription': 'Ocultar os títulos para os eixos.',
	'columnChartProp_maintainAxisScalesLabel': 'Manter escala do eixo',
	'columnChartProp_maintainAxisScalesDescription': 'Sempre exibir os valores mínimo e máximo nos eixos.',
	'columnChartProp_suppressZerosLabel': 'Ocultar vazio',
	'columnChartProp_suppressZerosDescription': 'Ocultar categorias sem nenhum valor associado.',
	'bubbleChartCaption': 'Bolha',
	'bubbleChartDataSlot_xAxisLabel': 'Eixo horizontal',
	'bubbleChartDataSlot_yAxisLabel': 'Eixo vertical',
	'bubbleChartDataSlot_sizeLabel': 'Dimensionar por',
	'bubbleChartDataSlot_colorLabel': 'Colorir por',
	'bubbleChartProp_colorPaletteLabel': 'Paletas de cores',
	'bubbleChartProp_hideGridLinesLabel': 'Ocultar linhas de grade',
	'bubbleChartProp_hideGridLinesDescription': 'Ocultar linhas de grade',
	'bubbleChartProp_hideAxisTitleLabelsLabel': 'Ocultar rótulos do título do eixo',
	'bubbleChartProp_hideAxisTitleLabelsDescription': 'Ocultar os títulos para os eixos.',
	'bubbleChartProp_maintainAxisScalesLabel': 'Manter escala do eixo',
	'bubbleChartProp_maintainAxisScalesDescription': 'Sempre exibir os valores mínimo e máximo nos eixos.',
	'bubbleChartProp_hideLegendLabel': 'Ocultar Legenda',
	'bubbleChartProp_hideLegendDescription': 'Ocultar a legenda.',
	'bubbleChartProp_legendPositionLabel': 'Ranqueamento de legenda',
	'lineChartCaption': 'Linha',
	'lineChartDataSlot_categoriesLabel': 'Etiqueta do eixo',
	'lineChartDataSlot_valuesLabel': 'Valor',
	'lineChartProp_colorPaletteLabel': 'Paletas de cores',
	'lineChartProp_lineColorLabel': 'Cor de linha e símbolo',
	'lineChartProp_symbolShapeLabel': 'Forma do símbolo',
	'lineChartProp_hideSymbolsLabel': 'Ocultar símbolos',
	'lineChartProp_hideSymbolsDescription': 'Ocultar símbolos',
	'lineChartProp_hideDataLinesLabel': 'Ocultar linha(s)',
	'lineChartProp_hideDataLinesDescription': 'Ocultar linha(s)',
	'lineChartProp_interpolationLabel': 'Linhas suaves',
	'lineChartProp_interpolationDescription': 'As linhas que conectam os pontos de dados são curvadas.',
	'lineChartProp_hideGridLinesLabel': 'Ocultar linhas de grade',
	'lineChartProp_hideGridLinesDescription': 'Ocultar linhas de grade',
	'lineChartProp_hideAxisTitleLabelsLabel': 'Ocultar rótulos do título do eixo',
	'lineChartProp_hideAxisTitleLabelsDescription': 'Ocultar os títulos para os eixos.',
	'lineChartProp_maintainAxisScalesLabel': 'Manter escala do eixo',
	'lineChartProp_maintainAxisScalesDescription': 'Sempre exibir os valores mínimo e máximo nos eixos.',
	'lineChartProp_suppressZerosLabel': 'Ocultar vazio',
	'lineChartProp_suppressZerosDescription': 'Ocultar categorias sem nenhum valor associado.',
	'packedBubbleChart1CatCaption': 'Bolhas compactadas',
	'packedBubbleChart1CatDataSlot_categoriesLabel': 'Categorias',
	'packedBubbleChart1CatDataSlot_sizeLabel': 'Dimensionar por',
	'packedBubbleChart1CatProp_colorPaletteLabel': 'Paletas de cores',
	'packedBubbleChart1CatProp_elementColorLabel': 'Cor da bolha',
	'packedBubbleChart1CatProp_hideLabelLabel': 'Ocultar rótulo',
	'packedBubbleChart1CatProp_hideValueLabel': 'Ocultar valor',
	'packedBubbleChart1CatProp_maintainAxisScalesLabel': 'Manter escala do eixo',
	'packedBubbleChart1CatProp_maintainAxisScalesDescription': 'Sempre exibir os valores mínimo e máximo nos eixos.',
	'packedBubbleChart1CatProp_suppressZerosLabel': 'Ocultar vazio',
	'packedBubbleChart1CatProp_suppressZerosDescription': 'Ocultar categorias sem nenhum valor associado.',
	'heatChartCaption': 'Temperatura',
	'heatChartDataSlot_valuesLabel': 'Utilização por',
	'heatChartDataSlot_xAxisLabel': 'Eixo horizontal',
	'heatChartDataSlot_yAxisLabel': 'Eixo vertical',
	'heatChartProp_colorPaletteLabel': 'Paletas de cores',
	'heatChartProp_heatScalePaletteLabel': 'Cor da ordem',
	'heatChartProp_hideAxisTitleLabelsLabel': 'Ocultar rótulos do título do eixo',
	'heatChartProp_hideAxisTitleLabelsDescription': 'Ocultar os títulos para os eixos.',
	'heatChartProp_maintainAxisScalesLabel': 'Manter escala do eixo',
	'heatChartProp_maintainAxisScalesDescription': 'Sempre exibir os valores mínimo e máximo nos eixos.',
	'heatChartProp_suppressZerosLabel': 'Ocultar vazio',
	'heatChartProp_suppressZerosDescription': 'Ocultar categorias sem nenhum valor associado.',
	'heatChartProp_hideLegendLabel': 'Ocultar Legenda',
	'heatChartProp_hideLegendDescription': 'Ocultar a legenda.',
	'heatChartProp_legendPositionLabel': 'Ranqueamento de legenda',
	'pieChartCaption': 'Setor Circular',
	'pieChartDataSlot_categoriesLabel': 'Categorias',
	'pieChartDataSlot_valuesLabel': 'Valor',
	'pieChartProp_colorPaletteLabel': 'Paletas de cores',
	'pieChartProp_hideRadialValueLabel': 'Ocultar valor',
	'pieChartProp_pieAsDonutLabel': 'Exibir como gráfico de rosca',
	'pieChartProp_pieAsDonutDescription': 'Exibir como gráfico de rosca',
	'pieChartProp_suppressZerosLabel': 'Ocultar vazio',
	'pieChartProp_suppressZerosDescription': 'Ocultar categorias sem nenhum valor associado.',
	'pieChartProp_hideLegendLabel': 'Ocultar Legenda',
	'pieChartProp_hideLegendDescription': 'Ocultar a legenda.',
	'pieChartProp_legendPositionLabel': 'Ranqueamento de legenda',
	'map1measureCaption': 'Mapa',
	'map1measureDataSlot_categoriesLabel': 'Regiões',
	'map1measureDataSlot_valuesLabel': 'Utilização da região',
	'map1measureProp_colorPaletteLabel': 'Paletas de cores',
	'map1measureProp_heatScalePaletteLabel': 'Cor da ordem',
	'map1measureProp_maintainAxisScalesLabel': 'Manter escala do eixo',
	'map1measureProp_maintainAxisScalesDescription': 'Sempre exibir os valores mínimo e máximo nos eixos.',
	'map1measureProp_suppressZerosLabel': 'Ocultar vazio',
	'map1measureProp_suppressZerosDescription': 'Ocultar categorias sem nenhum valor associado.',
	'map1measureProp_hideLegendLabel': 'Ocultar Legenda',
	'map1measureProp_hideLegendDescription': 'Ocultar a legenda.',
	'map1measureProp_legendPositionLabel': 'Ranqueamento de legenda',
	'radialChartCaption': 'Radial',
	'radialChartDataSlot_categoriesLabel': 'Categorias',
	'radialChartDataSlot_valuesLabel': 'Valor',
	'radialChartProp_colorPaletteLabel': 'Paletas de cores',
	'radialChartProp_elementColorLabel': 'Cor da barra radial',
	'radialChartProp_hideRadialTitleLabel': 'Ocultar título',
	'radialChartProp_hideRadialValueLabel': 'Ocultar valor',
	'radialChartProp_maintainAxisScalesLabel': 'Manter escala do eixo',
	'radialChartProp_maintainAxisScalesDescription': 'Sempre exibir os valores mínimo e máximo nos eixos.',
	'radialChartProp_suppressZerosLabel': 'Ocultar vazio',
	'radialChartProp_suppressZerosDescription': 'Ocultar categorias sem nenhum valor associado.',
	'pointChart1catCaption': 'Ponto',
	'pointChart1catDataSlot_valuesLabel': 'Valor',
	'pointChart1catDataSlot_categoriesLabel': 'Etiqueta do eixo',
	'pointChart1catProp_colorPaletteLabel': 'Paletas de cores',
	'pointChart1catProp_elementColorLabel': 'Cor da forma',
	'pointChart1catProp_symbolShapeLabel': 'Forma do símbolo',
	'pointChart1catProp_symbolFillLabel': 'Forma de preenchimento',
	'pointChart1catProp_symbolFillDescription': 'Exibir cor de preenchimento para os símbolos.',
	'pointChart1catProp_hideGridLinesLabel': 'Ocultar linhas de grade',
	'pointChart1catProp_hideGridLinesDescription': 'Ocultar linhas de grade',
	'pointChart1catProp_hideAxisTitleLabelsLabel': 'Ocultar rótulos do título do eixo',
	'pointChart1catProp_hideAxisTitleLabelsDescription': 'Ocultar os títulos para os eixos.',
	'pointChart1catProp_maintainAxisScalesLabel': 'Manter escala do eixo',
	'pointChart1catProp_maintainAxisScalesDescription': 'Sempre exibir os valores mínimo e máximo nos eixos.',
	'pointChart1catProp_suppressZerosLabel': 'Ocultar vazio',
	'pointChart1catProp_suppressZerosDescription': 'Ocultar categorias sem nenhum valor associado.',
	'scatterPlotChartNoCatCaption': 'Gráfico de dispersão',
	'scatterPlotChartNoCatDataSlot_xAxisLabel': 'Eixo horizontal',
	'scatterPlotChartNoCatDataSlot_yAxisLabel': 'Eixo vertical',
	'scatterPlotChartNoCatProp_colorPaletteLabel': 'Paletas de cores',
	'scatterPlotChartNoCatProp_elementColorLabel': 'Cor do elemento',
	'scatterPlotChartNoCatProp_symbolShapeLabel': 'Forma do símbolo',
	'scatterPlotChartNoCatProp_symbolFillLabel': 'Forma de preenchimento',
	'scatterPlotChartNoCatProp_symbolFillDescription': 'Exibir cor de preenchimento para os símbolos.',
	'scatterPlotChartNoCatProp_hideGridLinesLabel': 'Ocultar linhas de grade',
	'scatterPlotChartNoCatProp_hideGridLinesDescription': 'Ocultar linhas de grade',
	'scatterPlotChartNoCatProp_hideAxisTitleLabelsLabel': 'Ocultar rótulos do título do eixo',
	'scatterPlotChartNoCatProp_hideAxisTitleLabelsDescription': 'Ocultar os títulos para os eixos.',
	'radialBarChartCaption': 'Barra radial',
	'radialBarChartDataSlot_categoriesLabel': 'Categorias',
	'radialBarChartDataSlot_valuesLabel': 'Valor',
	'radialBarChartProp_colorPaletteLabel': 'Paletas de cores',
	'radialBarChartProp_elementColorLabel': 'Cor da barra radial',
	'radialBarChartProp_hideRadialTitleLabel': 'Ocultar título',
	'radialBarChartProp_maintainAxisScalesLabel': 'Manter escala do eixo',
	'radialBarChartProp_maintainAxisScalesDescription': 'Sempre exibir os valores mínimo e máximo nos eixos.',
	'radialBarChartProp_suppressZerosLabel': 'Ocultar vazio',
	'radialBarChartProp_suppressZerosDescription': 'Ocultar categorias sem nenhum valor associado.',
	'lineColumnComboChartCaption': 'Linha e coluna',
	'lineColumnComboChartDataSlot_categoryLabel': 'Etiqueta do eixo',
	'lineColumnComboChartDataSlot_lineValueLabel': 'Valor da linha',
	'lineColumnComboChartDataSlot_columnValueLabel': 'Valor da coluna',
	'lineColumnComboChartProp_colorPaletteLabel': 'Paletas de cores',
	'lineColumnComboChartProp_elementColorLabel': 'Cor da coluna',
	'lineColumnComboChartProp_lineColorLabel': 'Cor de linha e símbolo',
	'lineColumnComboChartProp_symbolShapeLabel': 'Forma do símbolo',
	'lineColumnComboChartProp_hideSymbolsLabel': 'Ocultar símbolos',
	'lineColumnComboChartProp_hideSymbolsDescription': 'Ocultar símbolos',
	'lineColumnComboChartProp_hideDataLinesLabel': 'Ocultar linha(s)',
	'lineColumnComboChartProp_hideDataLinesDescription': 'Ocultar linha(s)',
	'lineColumnComboChartProp_interpolationLabel': 'Linhas suaves',
	'lineColumnComboChartProp_interpolationDescription': 'As linhas que conectam os pontos de dados são curvadas.',
	'lineColumnComboChartProp_hideGridLinesLabel': 'Ocultar linhas de grade',
	'lineColumnComboChartProp_hideGridLinesDescription': 'Ocultar linhas de grade',
	'lineColumnComboChartProp_hideAxisTitleLabelsLabel': 'Ocultar rótulos do título do eixo',
	'lineColumnComboChartProp_hideAxisTitleLabelsDescription': 'Ocultar os títulos para os eixos.',
	'lineColumnComboChartProp_maintainAxisScalesLabel': 'Manter escala do eixo',
	'lineColumnComboChartProp_maintainAxisScalesDescription': 'Sempre exibir os valores mínimo e máximo nos eixos.',
	'lineColumnComboChartProp_suppressZerosLabel': 'Ocultar vazio',
	'lineColumnComboChartProp_suppressZerosDescription': 'Ocultar categorias sem nenhum valor associado.',
	'lineColumnComboChartProp_hideLegendLabel': 'Ocultar Legenda',
	'lineColumnComboChartProp_hideLegendDescription': 'Ocultar a legenda.',
	'lineColumnComboChartProp_legendPositionLabel': 'Ranqueamento de legenda',
	'summaryCaption': 'Resumo',
	'areaName': 'Área',
	'areaDescription': 'Área',
	'areaDataSlot_colorLabel': 'Colorir por',
	'areaDataSlot_valuesLabel': 'Valor',
	'areaDataSlot_categoriesLabel': 'Etiqueta do eixo',
	'bubbleName': 'Bolha',
	'bubbleDescription': 'Bolha',
	'bubbleDataSlot_yAxisLabel': 'Eixo vertical',
	'bubbleDataSlot_xAxisLabel': 'Eixo horizontal',
	'bubbleDataSlot_sizeLabel': 'Dimensionar por',
	'bubbleDataSlot_colorLabel': 'Colorir por',
	'clusterBarName': 'Barra',
	'clusterBarDescription': 'Barra',
	'clusterBarDataSlot_colorLabel': 'Colorir por',
	'clusterBarDataSlot_valuesLabel': 'Valor',
	'clusterBarDataSlot_categoriesLabel': 'Etiqueta do eixo',
	'clusterBarDataSlot_valuesRepeatingLabel': 'Valor',
	'clusterColumnName': 'Coluna',
	'clusterColumnDescription': 'Coluna',
	'clusterColumnDataSlot_colorLabel': 'Colorir por',
	'clusterColumnDataSlot_valuesLabel': 'Valor',
	'clusterColumnDataSlot_categoriesLabel': 'Etiqueta do eixo',
	'clusterColumnDataSlot_valuesRepeatingLabel': 'Valor',
	'clusterLineName': 'Linha',
	'clusterLineDescription': 'Linha',
	'clusterLineDataSlot_colorLabel': 'Colorir por',
	'clusterLineDataSlot_valuesLabel': 'Eixo vertical',
	'clusterLineDataSlot_categoriesLabel': 'Eixo horizontal',
	'clusterLineDataSlot_valuesRepeatingLabel': 'Valor',
	'gridName': 'Grade',
	'gridDescription': 'Grade',
	'gridDataSlot_grid_colsLabel': 'Coluna',
	'heatName': 'Temperatura',
	'heatDescription': 'Temperatura',
	'heatDataSlot_yAxisLabel': 'Eixo vertical',
	'heatDataSlot_xAxisLabel': 'Eixo horizontal',
	'heatDataSlot_valuesLabel': 'Utilização por',
	'lineColumnComboName': 'Linha e coluna',
	'lineColumnComboDescription': 'Linha e coluna',
	'lineColumnComboDataSlot_lineValueLabel': 'Valor da linha',
	'lineColumnComboDataSlot_categoryLabel': 'Etiqueta do eixo',
	'lineColumnComboDataSlot_columnValueLabel': 'Valor da coluna',
	'mapName': 'Mapa Anterior',
	'mapDescription': 'Mapa Anterior',
	'mapDataSlot_sizeLabel': 'Tamanho do ponto',
	'mapDataSlot_valuesLabel': 'Utilização da região',
	'mapDataSlot_sizeHeatLabel': 'Utilização do ponto',
	'mapDataSlot_categoriesLabel': 'Regiões',
	'packedBubbleName': 'Bolhas compactadas',
	'packedBubbleDescription': 'Bolhas compactadas',
	'packedBubbleDataSlot_sizeLabel': 'Dimensionar por',
	'packedBubbleDataSlot_colorLabel': 'Colorir por',
	'packedBubbleDataSlot_categoriesLabel': 'Categorias',
	'pieName': 'Setor Circular',
	'pieDescription': 'Setor Circular',
	'pieDataSlot_valuesLabel': 'Valor',
	'pieDataSlot_categoriesLabel': 'Categorias',
	'playerName': 'Reprodutor de dados',
	'playerDescription': 'Reprodutor de dados',
	'playerDataSlot_categoriesLabel': 'Etiqueta do eixo',
	'pointName': 'Ponto',
	'pointDescription': 'Ponto',
	'pointDataSlot_colorLabel': 'Colorir por',
	'pointDataSlot_valuesLabel': 'Valor',
	'pointDataSlot_categoriesLabel': 'Etiqueta do eixo',
	'radialName': 'Radial',
	'radialDescription': 'Radial',
	'radialDataSlot_valuesLabel': 'Valor',
	'radialDataSlot_maxSizeLabel': 'Valor máximo',
	'radialDataSlot_categoriesLabel': 'Categorias',
	'radialBarName': 'Barra radial',
	'radialBarDescription': 'Barra radial',
	'radialBarDataSlot_valuesLabel': 'Valor',
	'radialBarDataSlot_categoriesLabel': 'Categorias',
	'scatterPlotName': 'Gráfico de dispersão',
	'scatterPlotDescription': 'Gráfico de dispersão',
	'scatterPlotDataSlot_yAxisLabel': 'Eixo vertical',
	'scatterPlotDataSlot_xAxisLabel': 'Eixo horizontal',
	'scatterPlotDataSlot_colorLabel': 'Colorir por',
	'scatterPlotDataSlot_categoriesLabel': 'Pontos',
	'stackedBarName': 'Barra de pilhas',
	'stackedBarDescription': 'Barra de pilhas',
	'stackedBarDataSlot_colorLabel': 'Colorir por',
	'stackedBarDataSlot_valuesLabel': 'Valor',
	'stackedBarDataSlot_categoriesLabel': 'Etiqueta do eixo',
	'stackedBarDataSlot_valuesRepeatingLabel': 'Valor',
	'stackedColumnName': 'Coluna de pilhas',
	'stackedColumnDescription': 'Coluna de pilhas',
	'stackedColumnDataSlot_colorLabel': 'Colorir por',
	'stackedColumnDataSlot_valuesLabel': 'Valor',
	'stackedColumnDataSlot_categoriesLabel': 'Etiqueta do eixo',
	'stackedColumnDataSlot_valuesRepeatingLabel': 'Valor',
	'summaryChartName': 'Resumo',
	'summaryChartDescription': 'Resumo',
	'summaryChartDataSlot_valuesLabel': 'Valor',
	'treeMapName': 'Mapa de árvore',
	'treeMapDescription': 'Mapa de árvore',
	'treeMapDataSlot_colorLabel': 'Utilização por',
	'treeMapDataSlot_valuesLabel': 'Dimensionar por',
	'treeMapDataSlot_categoriesLabel': 'Nível um',
	'treeMapDataSlot_level3Label': 'Nível três',
	'treeMapDataSlot_level2Label': 'Nível dois',
	'wordCloudName': 'Nuvem de palavras',
	'wordCloudDescription': 'Nuvem de palavras',
	'wordCloudDataSlot_colorLabel': 'Colorir por',
	'wordCloudDataSlot_scaleLabel': 'Dimensionar por',
	'wordCloudDataSlot_wordLabel': 'Palavras',
	'treeMap1Cat1MeasureChartCaption': 'Mapa de árvore',
	'treeMap1Cat1MeasureChartDataSlot_categoriesLabel': 'Nível um',
	'treeMap1Cat1MeasureChartDataSlot_valuesLabel': 'Dimensionar por',
	'treeMap1Cat1MeasureChartProp_colorPaletteLabel': 'Paletas de cores',
	'treeMap1Cat2MeasureChartProp_colorPaletteLabel': 'Paletas de cores',
	'treeMap2Cat1MeasureChartProp_colorPaletteLabel': 'Paletas de cores',
	'treeMap2Cat2MeasureChartProp_colorPaletteLabel': 'Paletas de cores',
	'treeMap3Cat1MeasureChartProp_colorPaletteLabel': 'Paletas de cores',
	'treeMap3Cat2MeasureChartProp_colorPaletteLabel': 'Paletas de cores',
	'treeMap1Cat1MeasureChartProp_maintainAxisScalesLabel': 'Manter escala do eixo',
	'treeMap1Cat1MeasureChartProp_maintainAxisScalesDescription': 'Sempre exibir os valores mínimo e máximo nos eixos.',
	'treeMap1Cat1MeasureChartProp_suppressZerosLabel': 'Ocultar vazio',
	'treeMap1Cat1MeasureChartProp_suppressZerosDescription': 'Ocultar categorias sem nenhum valor associado.',
	'treeMap1Cat1MeasureChartProp_hideLegendLabel': 'Ocultar Legenda',
	'treeMap1Cat1MeasureChartProp_hideLegendDescription': 'Ocultar a legenda.',
	'treeMap1Cat1MeasureChartProp_legendPositionLabel': 'Ranqueamento de legenda',
	'wordChart1Cat1MeasureCaption': 'Nuvem de palavras',
	'wordChart1Cat1MeasureDataSlot_wordLabel': 'Palavras',
	'wordChart1Cat1MeasureDataSlot_scaleLabel': 'Dimensionar por',
	'wordChart1Cat1MeasureProp_colorPaletteLabel': 'Paletas de cores',
	'wordChart1Cat1MeasureProp_elementColorLabel': 'Cor da palavra',
	'wordChart1Cat1MeasureProp_maintainAxisScalesLabel': 'Manter escala do eixo',
	'wordChart1Cat1MeasureProp_maintainAxisScalesDescription': 'Sempre exibir os valores mínimo e máximo nos eixos.',
	'wordChart1Cat1MeasureProp_suppressZerosLabel': 'Ocultar vazio',
	'wordChart1Cat1MeasureProp_suppressZerosDescription': 'Ocultar categorias sem nenhum valor associado.',
	'missingDataSetData': 'Os dados para este conjunto de dados não estão disponíveis. Atualize o conjunto de dados ou entre em contato com o administrador para acessar a origem.',
	'hideShowSummaries': 'Ocultar mostrar resumos',
	'crosstabName': 'Tabela cruzada',
	'value_is_not_available': 'N/C',
	'swapRowsAndColumns': 'Trocar linhas e colunas',
	'NoPinsCollected': 'Nenhuma visualização fixada',
	'pinSearchOld': 'Procurar meus pinos',
	'pinDeletedToast': 'Pino foi removido',
	'pinAddedToast': 'Pino foi incluído com sucesso em Meus Pinos',
	'pinRetrieveError': 'Não é possível recuperar um ou mais alfinetes. Tente novamente mais tarde.',
	'pinErrorTitle': 'Erro ao Fixar',
	'pinRemove': 'Remover o pino',
	'deletePin': 'Excluir pino',
	'dataset_time': 'horário',
	'dataset_date': 'data',
	'dataset_location': 'posição',
	'dataset_number': 'número',
	'dataset_text': 'text',
	'widgetConditionalFormatLabel': 'Alternar controles de formato condicional',
	'deletePinConfirmationMessage': 'Tem certeza de que deseja excluir este pino? Esta ação não pode ser desfeita.',
	'deletePinConfirm': 'Confirmar Exclusão',
	'pinDeleteError': 'Não podemos excluir um ou mais alfinetes. Tente novamente mais tarde.',
	'conditionalPalettePickerLabel': 'Distribuição de %{title} valores',
	'HistogramYAxisTitle': 'Contar',
	'metadataPickerTitle': 'Criar Conjunto de Dados',
	'moreTitle': 'Mais',
	'remove_slider_handle': 'Remover identificador',
	'missingFiltering': 'Coluna ausente:',
	'unSupportedPromptType': 'O cenário do prompt não é suportado atualmente.',
	'preAggregateLabel': 'Aplicar valores de prompt da origem de dados',
	'postAggregateLabel': 'Aplicar valores de prompt no relatório',
	'preAggregateText': 'O intervalo usa os valores na origem de dados, não os valores exibidos no painel.',
	'tabName_general': 'Geral',
	'tabName_visDetails': 'Detalhes',
	'tabName_textDetails': 'Detalhes de texto',
	'tabName_mediaDetails': 'Detalhes de mídia',
	'tabName_webDetails': 'Detalhes da página da web',
	'tabName_imageDetails': 'Detalhes da Imagem',
	'tabName_visualization': 'Visualização',
	'sectionName_canvas': 'Tela',
	'sectionName_colorsAndThemes': 'Cor e tema',
	'sectionName_appearance': 'Aparência',
	'sectionName_advanced': 'Avançado',
	'sectionName_layout': 'Layout',
	'sectionName_tabs': 'Guias',
	'sectionName_tabTitle': 'Rótulo',
	'sectionName_tabBackground': 'Plano de Fundo',
	'addDataSourceDialogTitle': 'Incluir uma fonte de dados',
	'addDataSourceDialogButtonLabel': 'Incluir',
	'shapesDoubleChevron': 'Chevron duplo',
	'widgetsPanelTitle': 'Widgets',
	'widgetsPanelImageLibraryTab': 'Biblioteca de Imagens',
	'widgetsPanelSectionBasic': 'Básico',
	'widgetsPanelSectionAdvanced': 'Avançado',
	'widgetsPanelSectionShapes': 'Formas',
	'customWidgetsTitle': 'Widgets customizados',
	'filterItemCanvasMove': 'Incluir nas telas',
	'filterOverflowMenu_Global': 'Menu de estouro de todas as abas',
	'filterOverflowMenu_Tab': 'Menu de estouro desta aba',
	'filterOverflowMenu_Item': 'Menu de estouro do filtro',
	'filterOverflowMenu_Single': 'Menu de estouro',
	'filterItemEdit': 'Editar valores de filtro',
	'filterDeleteAllItems': 'Excluir todos os filtros',
	'filterClearAllItems': 'Limpar todos os filtros',
	'filterClearSelection': 'Limpe o filtro',
	'filterPlayerMode': 'Mostrar reprodutor',
	'filterStaticMode': 'Mostrar lista',
	'filterInvertSelection': 'Inverter Filtro',
	'filterIconLabel_Global': 'Todas as guias',
	'filterIconLabel_Single': 'Filtros',
	'filterIconLabel_Tab': 'Essa guia',
	'filterIconTooltip_Global': 'Todas as guias',
	'filterIconTooltip_Tab': 'Essa guia',
	'filterIconTooltip_Single': 'Filtros',
	'filterItemDelete': 'Excluir filtro',
	'filterValueSeparator': ',',
	'filterRange': '%{from} - %{to}',
	'filterInvertRange': 'tudo, exceto: %{from}-%{to}',
	'filterExcept': 'exceto %{values}',
	'filterAll': 'Todas',
	'filterBlank': '(em branco)',
	'filterDisableRangeInvert': 'Indisponível quando essa coluna estiver no filtro \'Todas as guias\'.',
	'filterDisableHierarchyInvert': 'Indisponível quando essa coluna for um filtro de hierarquia.',
	'filterSelectedOfTotal': '%{selected} de %{totalMembers}',
	'filter_date_before': 'Anterior a %{to}',
	'filter_date_before_except': 'Não anterior a %{to}',
	'filter_date_after': 'Após %{from}',
	'filter_date_after_except': 'Não após %{from}',
	'filter_date_between': 'Entre %{from}-%{to}',
	'filter_date_between_except': 'Não entre %{from}-%{to}',
	'filter_drag_and_drop_all_tabs': 'Arraste e solte dados aqui para filtrar todas as guias.',
	'filter_drag_and_drop_current_tab': 'Arraste e solte dados aqui para filtrar esta guia.',
	'filter_drag_and_drop_single_dock': 'Arraste e solte dados aqui para filtrar.',
	'errMsgFilterItemGenericTitle': 'Valores de filtro não podem ser carregados',
	'widgetChromeRotate': 'Girar',
	'toolbarRegionLabel': 'Barra de ferramentas',
	'toolbarActionDelete': 'Excluir',
	'toolbarActionGroup': 'Agrupar',
	'toolbarActionUngroup': 'Desagrupar',
	'toolbarActionOrderToFront': 'Enviar para frente',
	'toolbarActionOrderToBack': 'Enviar para trás',
	'toolbarActionEditTitle': 'Editar o título',
	'toolbarActionWrapTitle': 'Agrupar o título',
	'toolbarActionPin': 'Coleta',
	'toolbarActionPinOld': 'Número de Identificação Pessoal',
	'toolbarActionAlign': 'Alinhar',
	'alignWidgetLeft': 'Esquerda',
	'alignWidgetCenter': 'Centro',
	'alignWidgetRight': 'Direita',
	'alignWidgetTop': 'Superior',
	'alignWidgetMiddle': 'Meio',
	'alignWidgetBottom': 'Parte inferior',
	'toolbarChangeVisualization': 'Alterar visualização',
	'live_label': 'Gráfico',
	'filter_label': 'Filtrar',
	'one_named_live': 'Gráfico %{name}',
	'one_named_live_numbered': 'Gráfico %{name} (%{number})',
	'one_unknown_live': 'Gráfico',
	'one_unknown_live_numbered': 'Gráfico (%{number})',
	'few_live': 'Grupo de %{count} gráficos',
	'many_live': 'Grupo de %{count} gráficos',
	'one_custom': 'Widget customizado',
	'one_custom_named': '%{name}',
	'one_custom_named_numbered': '%{name} (%{number})',
	'one_named_filter': 'Filtro %{name}',
	'one_named_filter_numbered': 'Filtro %{name} (%{number})',
	'one_unknown_filter': 'Filtrar',
	'one_unknown_filter_numbered': 'Filtro (%{number})',
	'few_filter': 'Grupo de %{count} filtros',
	'many_filter': 'Grupo de %{count} filtros',
	'LIVE_bar_has_mapping': 'Gráfico de barras %{values}',
	'LIVE_bar_has_mapping_numbered': 'Gráfico de barras %{values} (%{number})',
	'LIVE_bar_opt_mapping': '%{categories} por %{values} gráfico de barras',
	'LIVE_bar_opt_mapping_numbered': '%{categories} por %{values} gráfico de barras (%{number})',
	'LIVE_bar_no_mapping': 'Gráfico de barras vazio',
	'LIVE_bar_no_mapping_numbered': 'Gráfico de barras vazio (%{number})',
	'LIVE_bar_named': 'Gráfico de barras %{name}',
	'LIVE_bar_named_numbered': 'Gráfico de barras %{name} (%{number})',
	'LIVE_stacked_bar_has_mapping': 'Gráfico de barras empilhadas %{values}',
	'LIVE_stacked_bar_has_mapping_numbered': 'Gráfico de barras empilhadas %{values} (%{number})',
	'LIVE_stacked_bar_opt_mapping': '%{categories} por %{values} gráfico de barras empilhadas',
	'LIVE_stacked_bar_opt_mapping_numbered': '%{categories} por %{values} gráfico de barras empilhadas (%{number})',
	'LIVE_stacked_bar_no_mapping': 'Gráfico de barras empilhadas vazio',
	'LIVE_stacked_bar_no_mapping_numbered': 'Gráfico de barras empilhadas vazio (%{number})',
	'LIVE_stacked_bar_named': 'Gráfico de barras empilhadas %{name}',
	'LIVE_stacked_bar_named_numbered': 'Gráfico de barras empilhadas %{name} (%{number})',
	'LIVE_bubble_has_mapping': '%{categories} por gráfico de bolhas %{x} e %{y}',
	'LIVE_bubble_has_mapping_numbered': '%{categories} por gráfico de bolhas %{x} e %{y} (%{number})',
	'LIVE_bubble_no_mapping': 'Gráfico de bolhas vazio',
	'LIVE_bubble_no_mapping_numbered': 'Gráfico de bolhas vazio (%{number})',
	'LIVE_bubble_named': 'Gráfico de bolhas %{name}',
	'LIVE_bubble_named_numbered': 'Gráfico de bolhas %{name} (%{number})',
	'LIVE_composite_has_mapping': '%{categories} por gráfico composto %{columnValue} e %{lineValue}',
	'LIVE_composite_has_mapping_numbered': '%{categories} por gráfico composto %{columnValue} e %{lineValue} (%{number})',
	'LIVE_composite_no_mapping': 'Gráfico composto vazio',
	'LIVE_composite_no_mapping_numbered': 'Gráfico composto vazio (%{number})',
	'LIVE_composite_named': 'Gráfico composto %{name}',
	'LIVE_composite_named_numbered': 'Gráfico composto %{name} (%{number})',
	'LIVE_decision_tree_has_mapping': '%{values} árvore de decisão',
	'LIVE_decision_tree_has_mapping_numbered': '%{values} árvore de decisão (%{number})',
	'LIVE_decision_tree_no_mapping': 'Árvore de decisão vazia',
	'LIVE_decision_tree_no_mapping_numbered': 'Arvore de decisão vazia (%{number})',
	'LIVE_decision_tree_named': 'Árvore de decisão %{name}',
	'LIVE_decision_tree_named_numbered': 'Árvore de decisão %{name} (%{number})',
	'LIVE_packed_bubble_has_mapping': 'Gráfico de bolhas compactado %{categories}',
	'LIVE_packed_bubble_has_mapping_numbered': 'Gráfico de bolhas compactado %{categories} (%{number})',
	'LIVE_packed_bubble_no_mapping': 'Gráfico de bolhas compactado vazio',
	'LIVE_packed_bubble_no_mapping_numbered': 'Gráfico de bolhas compactado vazio (%{number})',
	'LIVE_packed_bubble_named': 'Gráfico de bolhas compactado %{name}',
	'LIVE_packed_bubble_named_numbered': 'Gráfico de bolhas compactado %{name} (%{number})',
	'LIVE_pie_has_mapping': '%{categories} por %{values} gráfico de pizza',
	'LIVE_pie_has_mapping_numbered': '%{categories} por %{values} gráfico de pizza (%{number})',
	'LIVE_pie_no_mapping': 'Gráfico de pizza vazio',
	'LIVE_pie_no_mapping_numbered': 'Gráfico de pizza vazio (%{number})',
	'LIVE_pie_named': 'Gráfico de pizza %{name}',
	'LIVE_pie_named_numbered': 'Gráfico de pizza %{name} (%{number})',
	'LIVE_pie_as_donut_has_mapping': '%{categories} por %{values} gráfico de rosca',
	'LIVE_pie_as_donut_has_mapping_numbered': '%{categories} por %{values} gráfico de rosca (%{number})',
	'LIVE_pie_as_donut_no_mapping': 'Gráfico de rosca vazio',
	'LIVE_pie_as_donut_no_mapping_numbered': 'Gráfico de rosca vazio (%{number})',
	'LIVE_pie_as_donut_named': 'Gráfico de rosca %{name}',
	'LIVE_pie_as_donut_named_numbered': 'Gráfico de rosca %{name} (%{number})',
	'LIVE_line_has_mapping': '%{categories} por %{values} gráfico de linha',
	'LIVE_line_has_mapping_numbered': '%{categories} por %{values} gráfico de linha (%{number})',
	'LIVE_line_no_mapping': 'Gráfico de linha vazio',
	'LIVE_line_no_mapping_numbered': 'Gráfico de linha vazio (%{number})',
	'LIVE_line_named': 'Gráfico de linha %{name}',
	'LIVE_line_named_numbered': 'Gráfico de linha %{name} (%{number})',
	'LIVE_area_has_mapping': '%{categories} por %{values} gráfico de áreas',
	'LIVE_area_has_mapping_numbered': '%{categories} por %{values} gráfico de áreas (%{number})',
	'LIVE_area_no_mapping': 'Gráfico de áreas vazio',
	'LIVE_area_no_mapping_numbered': 'Gráfico de áreas vazio (%{number})',
	'LIVE_area_named': 'Gráfico de áreas %{name}',
	'LIVE_area_named_numbered': 'Gráfico de áreas %{name} (%{number})',
	'LIVE_area_as_stacked_percent_has_mapping': '%{categories} por %{values} gráfico de áreas de percentual empilhadas',
	'LIVE_area_as_stacked_percent_has_mapping_numbered': '%{categories} por %{values} gráfico de áreas de percentual empilhadas (%{number})',
	'LIVE_area_as_stacked_percent_no_mapping': 'Gráfico de áreas de percentual empilhado vazio',
	'LIVE_area_as_stacked_percent_no_mapping_numbered': 'Gráfico de áreas de percentual empilhadas vazio (%{number})',
	'LIVE_area_as_stacked_percent_named': 'Gráfico de áreas de percentual empilhadas %{name}',
	'LIVE_area_as_stacked_percent_named_numbered': 'Gráfico de áreas de percentual empilhadas %{name} (%{number})',
	'LIVE_heatmap_has_mapping': 'Mapa de calor %{color}',
	'LIVE_heatmap_has_mapping_numbered': 'Mapa de calor %{color} (%{number})',
	'LIVE_heatmap_no_mapping': 'Mapa de calor vazio',
	'LIVE_heatmap_no_mapping_numbered': 'Mapa de calor vazio (%{number})',
	'LIVE_heatmap_named': 'Mapa de calor %{name}',
	'LIVE_heatmap_named_numbered': 'Mapa de calor %{name} (%{number})',
	'LIVE_network_opt_mapping': '%{categories} por rede %{series} e %{values}',
	'LIVE_network_opt_mapping_numbered': '%{categories} por rede %{series} e %{values} (%{number})',
	'LIVE_network_has_mapping': '%{categories} por %{series} rede',
	'LIVE_network_has_mapping_numbered': '%{categories} por %{series} rede (%{number})',
	'LIVE_network_no_mapping': 'Rede vazia',
	'LIVE_network_no_mapping_numbered': 'Rede vazia (%{number})',
	'LIVE_network_named': 'Rede %{name}',
	'LIVE_network_named_numbered': 'Rede %{name} (%{number})',
	'LIVE_radial_bar_opt_mapping': '%{categories} por %{values} gráfico de barras radial',
	'LIVE_radial_bar_opt_mapping_numbered': '%{categories} por %{values} gráfico de barras radial (%{number})',
	'LIVE_radial_bar_has_mapping': 'Gráfico de barras radial %{values}',
	'LIVE_radial_bar_has_mapping_numbered': 'Gráfico de barras radial %{values} (%{number})',
	'LIVE_radial_bar_no_mapping': 'Gráfico de barras radial vazio',
	'LIVE_radial_bar_no_mapping_numbered': 'Gráfico de barras radial vazio (%{number})',
	'LIVE_radial_bar_named': 'Gráfico de barras radial %{name}',
	'LIVE_radial_bar_named_numbered': 'Gráfico de barras radial %{name} (%{number})',
	'LIVE_spiral_has_mapping': '%{values} gráfico espiral',
	'LIVE_spiral_has_mapping_numbered': '%{values} gráfico espiral (%{number})',
	'LIVE_spiral_no_mapping': 'Gráfico espiral vazio',
	'LIVE_spiral_no_mapping_numbered': 'Gráfico espiral vazio (%{number})',
	'LIVE_spiral_named': 'Gráfico espiral %{name}',
	'LIVE_spiral_named_numbered': '%{name} gráfico espiral (%{number})',
	'LIVE_treemap_has_mapping': '%{categories} por mapa de árvore %{size}',
	'LIVE_treemap_has_mapping_numbered': '%{categories} por mapa de árvore %{size} (%{number})',
	'LIVE_treemap_no_mapping': 'Mapa de árvore vazio',
	'LIVE_treemap_no_mapping_numbered': 'Mapa de árvore vazio (%{number})',
	'LIVE_treemap_named': 'Mapa de árvore %{name}',
	'LIVE_treemap_named_numbered': 'Mapa de árvore %{name} (%{number})',
	'LIVE_wordcloud_has_mapping': 'Nuvem de palavras %{categories}',
	'LIVE_wordcloud_has_mapping_numbered': 'Nuvem de palavras %{categories} (%{number})',
	'LIVE_wordcloud_no_mapping': 'Nuvem de palavras vazia',
	'LIVE_wordcloud_no_mapping_numbered': 'Nuvem de palavras vazia (%{number})',
	'LIVE_wordcloud_named': 'Nuvem de palavras %{name}',
	'LIVE_wordcloud_named_numbered': 'Nuvem de palavras %{name} (%{number})',
	'LIVE_data_player_has_mapping': 'Reprodutor de dados %{category}',
	'LIVE_data_player_has_mapping_numbered': 'Reprodutor de dados %{category} (%{number})',
	'LIVE_data_player_no_mapping': 'Reprodutor de dados vazio',
	'LIVE_data_player_no_mapping_numbered': 'Reprodutor de dados vazio (%{number})',
	'LIVE_data_player_named': 'Reprodutor de dados %{name}',
	'LIVE_data_player_named_numbered': 'Reprodutor de dados %{name} (%{number})',
	'LIVE_map_has_mapping': 'Mapa de %{locations}',
	'LIVE_map_has_mapping_numbered': 'Mapa de %{locations} (%{number})',
	'LIVE_map_no_mapping': 'Mapa vazio',
	'LIVE_map_no_mapping_numbered': 'Mapa vazio (%{number})',
	'LIVE_map_named': 'Mapa %{name}',
	'LIVE_map_named_numbered': 'Mapa %{name} (%{number})',
	'LIVE_point_has_mapping': '%{categories} por %{values} gráfico de pontos',
	'LIVE_point_has_mapping_numbered': '%{categories} por %{values} gráfico de pontos (%{number})',
	'LIVE_point_no_mapping': 'Gráfico de pontos vazio',
	'LIVE_point_no_mapping_numbered': 'Gráfico de pontos vazio (%{number})',
	'LIVE_point_named': 'Gráfico de pontos %{name}',
	'LIVE_point_named_numbered': 'Gráfico de pontos %{name} (%{number})',
	'LIVE_column_has_mapping': 'Gráfico de colunas %{values}',
	'LIVE_column_has_mapping_numbered': 'Gráfico de colunas %{values} (%{number})',
	'LIVE_column_opt_mapping': '%{categories} por %{values} gráfico de colunas',
	'LIVE_column_opt_mapping_numbered': '%{categories} por %{values} gráfico de colunas (%{number})',
	'LIVE_column_no_mapping': 'Gráfico de colunas vazio',
	'LIVE_column_no_mapping_numbered': 'Gráfico de colunas vazio (%{number})',
	'LIVE_column_named': 'Gráfico de colunas %{name}',
	'LIVE_column_named_numbered': 'Gráfico de colunas %{name} (%{number})',
	'LIVE_stacked_column_has_mapping': 'Gráfico de colunas empilhadas %{values}',
	'LIVE_stacked_column_has_mapping_numbered': 'Gráfico de colunas empilhadas %{values} (%{number})',
	'LIVE_stacked_column_opt_mapping': '%{categories} por %{values} gráfico de colunas empilhadas',
	'LIVE_stacked_column_opt_mapping_numbered': '%{categories} por %{values} gráfico de colunas empilhadas (%{number})',
	'LIVE_stacked_column_no_mapping': 'Gráfico de colunas empilhadas vazio',
	'LIVE_stacked_column_no_mapping_numbered': 'Gráfico de colunas empilhadas vazio (%{number})',
	'LIVE_stacked_column_named': 'Gráfico de colunas empilhadas %{name}',
	'LIVE_stacked_column_named_numbered': 'Gráfico de colunas empilhadas %{name} (%{number})',
	'LIVE_scatter_opt_mapping': 'Gráfico de dispersão de %{categories} por %{x} e %{y}',
	'LIVE_scatter_opt_mapping_numbered': 'Gráfico de dispersão de %{categories} por %{x} e %{y} (%{number})',
	'LIVE_scatter_has_mapping': 'Gráfico de dispersão de %{x} vs %{y}',
	'LIVE_scatter_has_mapping_numbered': 'Gráfico de dispersão de %{x} vs %{y} (%{number})',
	'LIVE_scatter_no_mapping': 'Gráfico de dispersão vazio',
	'LIVE_scatter_no_mapping_numbered': 'Gráfico de dispersão vazio (%{number})',
	'LIVE_scatter_named': 'Gráfico de dispersão %{name}',
	'LIVE_scatter_named_numbered': 'Gráfico de dispersão %{name} (%{number})',
	'LIVE_waterfall_has_mapping': '%{values} gráfico em cascata',
	'LIVE_waterfall_has_mapping_numbered': '%{values} gráfico em cascata (%{number})',
	'LIVE_waterfall_no_mapping': 'Gráfico em cascata vazio',
	'LIVE_waterfall_no_mapping_numbered': 'Gráfico em cascata vazio (%{number})',
	'LIVE_waterfall_named': '%{name} gráfico em cascata',
	'LIVE_waterfall_named_numbered': '%{name} gráfico em cascata (%{number})',
	'LIVE_empty_visualization_hint_title': 'Construa sua visualização',
	'LIVE_empty_visualization_hint_description': 'Arraste e solte colunas aqui ou nos slots à esquerda.',
	'LIVE_slots_required_field_description': '%{asterisk} Indica um campo obrigatório',
	'LIVE_slots_drag_and_drop_description': 'Arraste e solte dados nos slots acima para construir e filtrar a visualização.',
	'requiredField': 'Campo obrigatório',
	'fullScreenEnter': 'Inserir tela cheia',
	'fullScreenClose': 'Sair da tela cheia',
	'noExtraText_multipurpose': 'Sinalizador Multifinalidade',
	'noExtraText_multipurpose_numbered': 'Sinalizador Multifinalidade (%{number})',
	'one_placeholder_vis': 'Sinalizador de Visualização',
	'one_placeholder_vis_numbered': 'Sinalizador de Visualização (%{number})',
	'one_placeholder_text': 'Texto do sinalizador',
	'one_placeholder_text_numbered': 'Sinalizador de texto (%{number})',
	'few_placeholder_text': 'Grupo de %{count} sinalizadores de texto',
	'many_placeholder_text': 'Grupo de %{count} sinalizadores de texto',
	'filter_includesAll': 'Inclui todos',
	'timeline_filter_moved_to': 'O filtro de linha de tempo %{id} foi movido para %{time}',
	'timelineSettingsButton': 'Opções de Reprodução',
	'autoPlay': 'Reproduzir todas as cenas',
	'loop': 'Laço',
	'noSceneTransitionLabel': 'Nenhum',
	'sceneTransitionPropertyLabel': 'Transição de cenário',
	'animatedPathSceneTransitionLabel': 'Caminho animado',
	'sweepSceneTransitionLabel': 'Tempo de Acesso',
	'propAniAnimation': 'Animação',
	'propAniTypeEntrance': 'Animação de entrada',
	'propAniDirectionIn': 'Direção de entrada',
	'propAniTypeExit': 'Animação de saída',
	'propAniDirectionOut': 'Direção de saída',
	'propAniDirection': 'Direção',
	'timelineAnimationProperties': 'Abrir propriedades de animação',
	'editStoryCoachMarkTitle': 'Editar história',
	'editStoryCoachMarkContents': 'Clique no ícone de lápis para editar esta história.',
	'addDataStoryCoachMarkContents': 'Arrastar e soltar dados a partir do painel de dados em sua história.',
	'expandSceneCoachmarkTitle': 'Abrir linha de tempo',
	'expandSceneCoachmarkContents': 'Anime uma cena ajustando a visibilidade do objeto com base no horário e na duração.',
	'overviewCoachmarkTitle': 'Cenários de visão geral',
	'overviewCoachmarkContents': 'Use os cenários de visão geral para iniciar e finalizar sua história para mostrar a visão global de todos os cenários. Em um cenário de visão geral, clique e arraste um cenário para trocá-lo por outro cenário. É possível mostrar ou ocultar os cenários de visão geral nas propriedades da história.',
	'animatedPathCoachmarkTitle': 'Caminho animado',
	'animatedPathCoachmarkContents': 'Para animar um objeto de um cenário para outro, duplique um cenário com um objeto. Em seguida, mova, redimensione ou gire o objeto duplicado no novo cenário.',
	'tabName_animation': 'Animação',
	'textWidgetIconPlaceholderText': 'Clique para incluir texto',
	'visIconPlaceholderText': 'Arraste e solte dados para construir uma visualização',
	'launchNewExplore': 'Nova exploração',
	'addTo': 'Incluir em',
	'addToExisting': 'Incluir existente ...',
	'exploreData': 'Explorar',
	'explore_remove_widget_styles': 'Propriedades de visualização customizada, como configurações de cor, não persistirão em sua exploração.',
	'editNotebook': 'Editar Widget',
	'thumbnails_error_fetching': 'Erro ao buscar as miniaturas',
	'copy': '%{count} ativo (s) copiado',
	'specConvertErr': 'Ocorreu um erro ao colar ou converter a especificação de painel',
	'specCopyErr': 'Erro ao copiar especificação de painel',
	'pasteNotSupportedErr': 'Não é suportado colar a partir de um %{name}.',
	'reportParam': 'relatório',
	'filterWidgetCopyWarn': 'A visualização do filtro não foi copiada, porque os Filtros não são suportados no momento.',
	'upgradingDashboard': 'Atualizando \'%{name}\' para %{version}...',
	'upgradeComplete': 'Upgrade concluído',
	'individualTabProperties': 'Propriedades da guia individual',
	'propMasterTabStylesLabel': 'Estilo da guia principal',
	'propTabPosition': 'Posição da guia',
	'propTabTitle': 'Título',
	'propTabBackgroundColor': 'Cor de preenchimento',
	'propTabTextColor': 'Cor do título',
	'propTabSelectedBarColor': 'Cor da barra selecionada',
	'propTabRestoreDefaults': 'Restaurar padrões',
	'propIndividualTabStylesLabel': 'Estilo de guia individual',
	'propIndividualTabStylesAriaLabel': 'Abrir propriedades de estilo de guia individual',
	'propTabIconPosition': 'Posição do ícone',
	'propLeftTitle': 'Esquerda do título',
	'propRightTitle': 'Direito do título',
	'propTopTitle': 'Acima do título',
	'propBottomTitle': 'Abaixo do título',
	'propTabIconLabel': 'Visual',
	'propTabIcon': 'Ícone',
	'propTabIconColor': 'Cor dos ícones',
	'no_icon': 'Vazio',
	'announcement': 'Anúncio',
	'api': 'Api',
	'archive': 'Archive',
	'asset': 'Recursos',
	'attachment': 'Anexo',
	'audio': 'Áudio',
	'bee': 'Bee',
	'blog': 'Blog',
	'bookmark': 'Marcador',
	'calendar': 'Calendário',
	'camera': 'Câmera',
	'capability': 'Capacidade',
	'catalog': 'Catálogo',
	'chat_message': 'Mensagem do bate-papo',
	'checkout_cart': 'Efetuar check-out do carrinho de compras',
	'client': 'Cliente',
	'clock': 'Relógio',
	'cloud': 'Nuvem',
	'code': 'Code',
	'data_quality': 'Qualidade de dados',
	'folder': 'Pastas',
	'forum': 'Fórum',
	'glasses': 'Óculos',
	'group': 'Agrupar',
	'hat': 'Chapéu',
	'headphone': 'Fone de ouvido',
	'hills': 'Hills',
	'home': 'Início',
	'idea': 'Ideia',
	'image': 'Imagem',
	'inventory': 'Inventário do Tivoli',
	'like': 'Curtir',
	'link': 'Link',
	'location': 'Localização',
	'manage': 'Gerenciar',
	'pen': 'Pen',
	'mobile_phone': 'Telefone celular',
	'music': 'Músicas',
	'notifications': 'Notificações',
	'paint': 'Tinta',
	'payment': 'Pagamento',
	'password_key': 'Chave senha',
	'people': 'Pessoal',
	'person': 'Membro',
	'phone': 'Phone',
	'pin': 'Número de Identificação Pessoal',
	'print': 'Imprimir',
	'recording': 'Gravação',
	'repository': 'Depósito',
	'role': 'Função',
	'search': 'Procurar',
	'properties': 'Propriedades',
	'speaker': 'Palestrante',
	'star': 'Estrela',
	'tag': 'Tag',
	'thumbs_up': 'Animado',
	'thumbs_down': 'Desanimado',
	'tools': 'Ferramentas',
	'traffic': 'Tráfego',
	'trash': 'Lixeira',
	'twitter': 'Twitter',
	'unknown': 'Desconhecida',
	'user': 'Usuário',
	'venn_diagram': 'diagrama de Venn',
	'video': 'Vídeo',
	'view': 'Visualização',
	'warning': 'Aviso',
	'watch': 'Assistir',
	'watson': 'Watson',
	'wikis': 'Wikis',
	'workspace': 'Espaço de Trabalho',
	'world': 'Mundo',
	'OnLoadFilterModifierDatasourceMismatch': 'Os filtros não serão aplicados ao destino porque os painéis estão usando origens diferentes.',
	'OnLoadFilterModifierColumnMismatch': 'Um ou mais filtros não foram aplicados porque a coluna correspondente não foi localizada.',
	'eventGroupButtonLabel': 'Visualizar conexões do widget',
	'dockToolbar': 'Acoplar barra de ferramentas',
	'undockToolbar': 'Desacoplar barra de ferramentas',
	'propShowTitle': 'Mostrar título'
});
